import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { EditorialFlexModule } from "src/typings/microserviceModels/content-flex-module";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { UitkSpacing } from "uitk-react-spacing";

export const CitiRewardsWithoutCompSectionEditorial = (props: {
  model: EditorialFlexModule;
  context: ExtendedContextStore;
}) => {
  const {
    model: { items: textElements },
    context: { deviceInformation },
  } = props;
  const items = (textElements && textElements.filter((textElement) => textElement)) || [];
  const { tablet: isTablet, mobile: isMobile } = deviceInformation || {};
  const headingClassNames =
    "all-x-padding-six all-t-padding-twelve s-t-padding-three all-b-padding-two s-x-padding-two";
  const subheadingClassNames = "xl-b-padding-six l-b-padding-six all-x-padding-six s-x-padding-two";
  const tabelClassNames =
    "s-b-padding-six s-l-padding-one m-b-padding-twelve  l-b-padding-twelve xl-b-padding-twelve  all-l-padding-twelve all-r-padding-four m-t-padding-six s-t-padding-six";
  const iconClassNames = "m-l-padding-two";
  const imageColSpan: UitkLayoutConditionalGridSpan = { small: 6, medium: 5, large: 5, extra_large: 5 };
  const iconColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 3, large: 2, extra_large: 2 };
  const imagegridColumns = {
    extra_large: 12,
    large: 12,
    medium: 12,
    small: 1,
  } as const;
  const textgridColumns = {
    extra_large: 12,
    large: 12,
    medium: 12,
    small: 6,
  } as const;

  if (items.length !== 8) {
    return null;
  }

  const [
    image,
    headingText,
    subHeadingText,
    flightIcon,
    hotelIcon,
    carIcon,
    activityIcon,
    vacationIcon,
  ] = items.map((item) => decorateEditorialHtml(item.text));
  const altText = image.__html;
  const media = items[0].media;
  let mediaUrl = media && media[1].mediaUrl;
  if (isMobile) {
    mediaUrl = media && media[0].mediaUrl;
  } else if (isTablet) {
    mediaUrl = media && media[2].mediaUrl;
  }

  return (
    <UitkSpacing padding={{ inline: "twelve", block: "twelve" }}>
      <UitkCardAloha border>
        <UitkLayoutGrid columns={imagegridColumns}>
          <UitkLayoutGridItem colSpan={imageColSpan}>
            <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
              <UitkImage src={mediaUrl} alt={altText} />
            </UitkFigure>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem colSpan={6}>
            <div>
              <UitkCardAlohaContentSection>
                <UitkText align="left" size={700} weight="bold">
                  <div className={headingClassNames} dangerouslySetInnerHTML={headingText} />
                </UitkText>

                <UitkText align="left" size={300} weight="regular">
                  <div className={subheadingClassNames} dangerouslySetInnerHTML={subHeadingText} />
                </UitkText>
              </UitkCardAlohaContentSection>

              <UitkCardAlohaContentSection>
                <UitkLayoutGrid rows={1} columns={textgridColumns} space="six" className={tabelClassNames}>
                  <UitkLayoutGridItem colSpan={2}>
                    <div>
                      <UitkText align="center" size={300} weight="regular">
                        <div dangerouslySetInnerHTML={flightIcon} />
                      </UitkText>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem colSpan={2}>
                    <div className={iconClassNames}>
                      <UitkText align="center" size={300} weight="regular">
                        <div dangerouslySetInnerHTML={hotelIcon} />
                      </UitkText>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem colSpan={2}>
                    <div className={iconClassNames}>
                      <UitkText align="center" size={300} weight="regular">
                        <div dangerouslySetInnerHTML={carIcon} />
                      </UitkText>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem colSpan={iconColSpan}>
                    <div className={iconClassNames}>
                      <UitkText align="center" size={300} weight="regular">
                        <div dangerouslySetInnerHTML={activityIcon} />
                      </UitkText>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem colSpan={iconColSpan}>
                    <div className={iconClassNames}>
                      <UitkText align="center" size={300} weight="regular">
                        <div dangerouslySetInnerHTML={vacationIcon} />
                      </UitkText>
                    </div>
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </UitkCardAlohaContentSection>
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </UitkCardAloha>
    </UitkSpacing>
  );
};
export default CitiRewardsWithoutCompSectionEditorial;
